import { Action } from 'redux';

import * as Const from '../constants';

export const pMethodInit = (): Action => {
  return {
    type: Const.PM_INIT,
  };
};

export const pMethodError = (): Action => {
  return {
    type: Const.PM_ERROR,
  };
};

export const pMethodLoading = (): Action => {
  return {
    type: Const.PM_PENDING,
  };
};
